// src/menu-items/tenants.js
import { UnorderedListOutlined, BarChartOutlined } from '@ant-design/icons';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';

import { ROLES } from '../lib/auth/roles';

// icons
const icons = {
  UnorderedListOutlined,
  BarChartOutlined,
  CameraAltOutlinedIcon
};

// Free Mantis supports only "group" + "item". No "collapse".
const tenants = {
  id: 'group-tenants',
  title: 'Management Tools',
  type: 'group',
  children: [
    // —— Emerson items (flat) ——
    {
      id: 'emerson-home',
      title: 'Add Free Lists',
      type: 'item',
      url: '/emerson',
      icon: icons.UnorderedListOutlined,
      breadcrumbs: false,
      allowedRoles: [ROLES.EMERSON] // Admin still sees via override
    },
    {
      id: 'emerson-reports',
      title: 'Reports',
      type: 'item',
      url: '/emerson/reports',
      icon: icons.BarChartOutlined,
      breadcrumbs: false,
      allowedRoles: [ROLES.EMERSON]
    },

    // —— Yours Truly items (flat) ——
    {
      id: 'yt-home',
      title: 'Add Free Lists',
      type: 'item',
      url: '/yours-truly',
      icon: icons.UnorderedListOutlined,
      breadcrumbs: false,
      allowedRoles: [ROLES.YOURS_TRULY]
    },
    {
      id: 'yt-hosts',
      title: 'Manage Host Frees',
      type: 'item',
      url: '/yours-truly/hosts',
      icon: icons.UnorderedListOutlined,
      breadcrumbs: false,
      allowedRoles: [ROLES.YOURS_TRULY]
    },
    {
      id: 'yt-bookings',
      title: 'Reports',
      type: 'item',
      url: '/yours-truly/reports',
      icon: icons.BarChartOutlined,
      breadcrumbs: false,
      allowedRoles: [ROLES.YOURS_TRULY]
    },

    // —— Bar Bambi items (flat) ——
    {
      id: 'bar-bambi-home',
      title: 'Add Free Lists',
      type: 'item',
      url: '/bar-bambi',
      icon: icons.UnorderedListOutlined,
      breadcrumbs: false,
      allowedRoles: [ROLES.BAR_BAMBI]
    },
    {
      id: 'bar-bambi-reports',
      title: 'Reports',
      type: 'item',
      url: '/bar-bambi/reports',
      icon: icons.BarChartOutlined,
      breadcrumbs: false,
      allowedRoles: [ROLES.BAR_BAMBI]
    },
    {
      id: 'bar-bambi-host-photo-attendance',
      title: 'Host Attendance',
      type: 'item',
      url: '/bar-bambi/host-photo-attendance',
      icon: icons.CameraAltOutlinedIcon,
      breadcrumbs: false,
      allowedRoles: [ROLES.BAR_BAMBI]
    }
  ]
};

export default tenants;
